<button
  [type]="type"
  [attr.id]="'id'"
  class="btn btn-{{ setStyle() }} {{ class }}"
  [disabled]="disabled"
  (click)="onClick()"
>
  <app-icon [name]="icon" *ngIf="isIconShown && icon && iconPosition === 'left'"></app-icon>
  {{ label }}
  <app-icon [name]="icon" *ngIf="isIconShown && icon && iconPosition === 'right'"></app-icon>
</button>
